export const getFormatedCSV = (data = []) => {
    return data.map((item) => ({
        "Nombre": item.name,
        "Fecha de Inicio": new Date(item.startedDate).toLocaleDateString(),
        "Fecha de Cierre": new Date(item.endFinishDate).toLocaleDateString(),
        "Semanas estimadas": item.weeksComercial,
        "Semanas trabajadas": item.weeksEquivalentStartAndEnd,
        "Brecha entre semanas": item.difference,
        "Tiene pausas": item.hasPause ? "Sí" : "No",
        "Comercial": item.comercial,
        "Lideres": item.leaders,
        "Responsable": item.responsible,
    }))
}

export const getTotalWeeks = (data = []) => {
    const { weeksEstimate, weeksWorked } = data
        .reduce((acc, item) => {
            acc.weeksEstimate += item.weeksComercial
            acc.weeksWorked += item.weeksEquivalentStartAndEnd
            return acc
        }, { weeksEstimate: 0, weeksWorked: 0 })

    const difference = weeksEstimate - weeksWorked
    return {
        weeksEstimate,
        weeksWorked,
        difference
    }
}

export const getLineChart = (data = []) => {
    const sortData = data.sort((a, b) => {
        if (a.weeksComercial !== b.weeksComercial) {
            return a.weeksComercial - b.weeksComercial; // Ascendente
        }
        return a.weeksEquivalentStartAndEnd - b.weeksEquivalentStartAndEnd; // Ascendente
    })

    const { dataEstimate, dataWorked } = sortData.reduce((acc, item, index) => {
        const nameX = item.name
        const infoDataEstimate = {
            x: nameX,
            y: item.weeksComercial
        }
        const infoDataWorked = {
            x: nameX,
            y: item.weeksEquivalentStartAndEnd
        }
        acc.dataEstimate.push(infoDataEstimate)
        acc.dataWorked.push(infoDataWorked)
        return acc
    }, { dataEstimate: [], dataWorked: [] })

    return [
        {
            color: "#1677FF",
            id: "Estimadas",
            data: dataEstimate
        },
        {
            color: "#1B1464",
            id: "Trabajadas",
            data: dataWorked
        }
    ]
}
